<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <h3 class="card-header-title">تعديل الاختبار</h3>
          </div>
          <div class="card-body">
            <form @submit.prevent="updateLessonExam()">
              <div class="card-body__form">
                <!-- Exam Main Info -->
                <div class="row">
                  <!-- Exam Title -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamTitle">عنوان الاختبار</label>
                      <input
                        type="text"
                        class="form-control mt-2"
                        id="ExamTitle"
                        placeholder="عنوان الاختبار"
                        v-model="exam.title"
                        required
                      />
                    </div>
                  </div>
                  <!-- Exam Duration -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamDuration">مدة الاختبار</label>
                      <input
                        type="number"
                        class="form-control mt-2"
                        id="ExamDuration"
                        min="1"
                        placeholder="مدة الاختبار بالدقائق"
                        v-model="exam.duration"
                        required
                      />
                    </div>
                  </div>
                  <!-- Exam Degree -->
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for="ExamDegree">مجموع الاختبار</label>
                      <input
                        type="number"
                        class="form-control mt-2"
                        id="ExamDegree"
                        placeholder="مجموع الاختبار"
                        :value="totalDegree"
                        readonly
                      />
                      <small class="text-muted">يتم حسابه من درجات الاسئلة</small>
                    </div>
                  </div>
                  <!-- Show Correct Answer -->
                  <div class="col-lg-3">
                    <div class="form-group">
                      <label for="examCorrectAnswer"
                        >امكانية عرض الاجابات الصحيحة</label
                      >
                      <select
                        class="form-select form-control mt-2"
                        aria-label="Default select "
                        v-model="exam.showCorrectAnswer"
                      >
                        <option selected disabled value="">
                          امكانية عرض الاجابات الصحيحة
                        </option>
                        <option :value="false">لا تعرض الاجابات الصحيحة</option>
                        <option :value="true">عرض الاجابات الصحيحة</option>
                      </select>
                    </div>
                  </div>
                  <!-- Is Repeat Exam -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="examRepeat">امكانية اعادة الاختبار</label>
                      <select
                        class="form-select form-control mt-2"
                        aria-label="Default select "
                        v-model="exam.isRepeat"
                      >
                        <option selected disabled value="">
                          امكانية اعادة الاختبار
                        </option>
                        <option :value="false">لا يمكن اعادة الاختبار</option>
                        <option :value="true">يمكن اعادة الاختبار</option>
                      </select>
                    </div>
                  </div>

                  <!-- Exam Start -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamStartDate">بداية الاختبار</label>
                      <input
                        type="datetime-local"
                        class="form-control mt-2"
                        id="ExamStartDate"
                        placeholder="بداية الاختبار"
                        :min="today"
                        v-model="exam.start_date"
                        required
                      />
                    </div>
                  </div>

                  <!-- Exam End -->
                  <div class="col-lg-6">
                    <div class="form-group">
                      <label for="ExamEndDate">نهاية الاختبار</label>
                      <input
                        type="datetime-local"
                        class="form-control mt-2"
                        id="ExamEndDate"
                        placeholder="نهاية الاختبار"
                        v-model="exam.end_date"
                        :min="today"
                        required
                      />
                    </div>
                  </div>
                </div>
                <ExamQuestionsEditor v-model:questions="exam.questions" />
              </div>

              <div class="card-footer">
                <button type="submit" class="btn btn-primary">حفظ</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// Vuex
import { mapActions } from "vuex";

// Swal
import Swal from "sweetalert2";

// Shared question form + questions table + edit modal
import ExamQuestionsEditor from "@/components/ExamQuestionsEditor.vue";
import { questionsTotalDegree } from "@/constants/exam";

export default {
  name: "AddLessonEditExam",
  components: {
    ExamQuestionsEditor,
  },
  data() {
    return {
      examId: this.$route.params.index,
      // min Value in input date
      today: new Date().toISOString().substr(0, 10),
      exam: {
        type: 3, // exams
        title: "",
        duration: "",
        degree: "",
        start_date: "",
        end_date: "",
        isRepeat: true,
        showCorrectAnswer: false,
        categories: [],
        questions: [],
        fullCategoriesInfo: [],
      },
    };
  },
  methods: {
    ...mapActions("lessonsModule", [
      // Get By ID
      "getExamByID",

      // Upadted
      "updateExamById",
    ]),

    async updateLessonExam() {
      if (this.exam.questions.length === 0) {
        this.showError("قم بأضافة سؤال واحد على الأقل");
        return;
      }

      // The exam total is always the sum of its questions' marks.
      this.exam.degree = this.totalDegree;

      try {
        await this.updateExamById(this.exam);
        Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        }).fire({ icon: "success", title: "تم تعديل الاختبار بنجاح" });
        this.$router.go(-1);
      } catch (error) {
        console.error("Could not save the exam", error);
        this.showError("لم يتم حفظ الاختبار، حاول مرة اخرى");
      }
    },


    showError(title) {
      Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
      }).fire({ icon: "error", title });
    },
  },
  async created() {
    this.exam = await this.getExamByID(this.examId);
  },

  computed: {
    // Never typed by hand: the exam total is the sum of the question marks.
    totalDegree() {
      return questionsTotalDegree(this.exam.questions);
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped></style>
